import { Checkbox } from 'platform/components';
import { HEADER_CELL_BORDER_BOTTOM } from '../../../../constants/borderStyles';
import { SELECTION_COLUMN_WIDTH, SELECTION_TEST_ID_PREFIX } from '../../../../constants/selectionColumn';
import { useGridRows } from '../../../../store/selectors/useGridRows';
import { useSelectedRowIds } from '../../../../store/selectors/useSelectedRowIds';
import { useEagGridStore } from '../../../../store/useEagGridStore';
export type SelectAllCheckboxProps = {
  /** Sticky top offset in px. 0 when no group header row is shown; GROUP_HEADER_ROW_HEIGHT when visible. */
  stickyTop: number;
};
export function SelectAllCheckbox(props: SelectAllCheckboxProps) {
  const store = useEagGridStore();
  const selectedRowIds = useSelectedRowIds();
  const rows = useGridRows();

  // Derive tri-state during render (not in effect) — Vercel: rerender-derived-state-no-effect
  const selectedCount = selectedRowIds.size;
  const totalCount = rows.length;
  const isAllSelected = totalCount > 0 && selectedCount === totalCount;
  const isIndeterminate = selectedCount > 0 && selectedCount < totalCount;
  const handleToggleAll = () => {
    if (isAllSelected) {
      store.deselectAll();
    } else {
      store.selectAll(rows.map(row => row.id));
    }
  };
  return <th className="p-0 text-center select-none font-normal bg-white" style={{
    width: SELECTION_COLUMN_WIDTH,
    position: 'sticky',
    top: props.stickyTop,
    left: 0,
    zIndex: 'var(--z-content-loader)',
    ...HEADER_CELL_BORDER_BOTTOM
  }}>
      <div className="flex items-center justify-center h-full">
        <Checkbox value={isAllSelected} isIndeterminate={isIndeterminate} onChange={handleToggleAll} data-testid={`${SELECTION_TEST_ID_PREFIX}-all`} />
      </div>
    </th>;
}